// extracted by mini-css-extract-plugin
export default {"title":"Laa-z","warning":"Maa-z","sizeOptionsLegendText":"Naa-z"};